const imageLocation = `${window.location.origin}/images/mfalogo.png`

export const getTOTPURI = (secretCode: string, userEmail?: string) =>
	`otpauth://totp/Finlert${userEmail ? ':' + userEmail : ''}?secret=${secretCode}&issuer=Finlert&image=${encodeURIComponent(imageLocation)}`
